'use strict';


const IS_DEBUG = false; //如果是测试环境就是true，如果是生产环境就是false
const commonUrl = IS_DEBUG ? 'api/' : '//t.cnbooking.net/api/' //生产
    // const commonUrl = IS_DEBUG ? 'api/' : '//192.168.18.103:8099/api/' //测试
    // const commonUrl = IS_DEBUG ? 'api/' : '//lmy-api-test.cnbooking.net/api/' //测试
export default {
    //cnbooking api config
    login: commonUrl + 'Token',
    wxlogin: commonUrl + 'Token/WX',
    anonymous: commonUrl + 'Token/Anonymous', //小程序匿名登录
    smslogin: commonUrl + 'Token/SMS',
    payCode: 'lmy-api-test.cnbooking.net',
    domain: 'lmy.cnbooking.net', //支付地址
    checkAccount: commonUrl + 'Account', //获取用户是否为代理信息
    getShareParam: commonUrl + 'Data/ShareParam',
    banner: commonUrl + 'Banner/BigBanner',
    bannerPresale: commonUrl + 'Banner/SmallBanner', //预售轮播图列表
    getPromotionAD: commonUrl + 'Banner/PromotionAD',
    weiFang: commonUrl + 'WeiFang',
    hotel: commonUrl + 'Hotel/Detail', //单个酒店信息/房型/价格查询
    price: commonUrl + 'Hotel/Search', //价格搜索
    getLowestPrices: commonUrl + 'Prices/LowestPrices', //异步批量价格搜索

    getLandmark: commonUrl + 'Suggestion/Landmark', //获取行政区和商圈
    getLandmarkGroups: commonUrl + 'Suggestion/LandmarkGroups', //获取地标分组
    cnHotCity: commonUrl + 'Data/CNHotCity', //国内热门城市
    foreignHotCity: commonUrl + 'Data/ForeignHotCity', //海外热门城市
    getHotCityHotels: commonUrl + 'Data/HotCityHotels', //热门城市

    cruiseDepartures: commonUrl + 'Data/CruiseDepartures', //获取邮轮出发地
    cruiseCompanys: commonUrl + 'Data/CruiseCompanys', //获取邮轮出发地
    getTravelDestinations: commonUrl + 'Data/ZYXDestinations', //获取自游行目的地
    getLocateCity: commonUrl + 'Data/LocateCity', //匹配城市,

    create_page_auth: commonUrl + 'Data/create_page_auth', //创建权限
    getPromotions: commonUrl + 'Promotions', //新客立减
    autoComplete: commonUrl + 'Suggestion/Hotel', //获取酒店自动完成信息
    autoCityComplete: commonUrl + 'Suggestion/Region', //获取城市/区域自动完成信息
    getOrderList: commonUrl + 'Orders/Search', //订单查询
    getOrderDetails: commonUrl + 'Orders', //订单查询详情
    getCommissionList: commonUrl + 'Orders/Commission', //佣金订单列表
    getAubAccounts: commonUrl + 'Account/SubAccounts', //获取子账号列表
    getIsSubscribed: commonUrl + 'Account/IsSubscribed', //获取账号是否已经关注了公众号
    getUserQR: commonUrl + 'Account/QR', //获取账号推广二维码
    getMyUserQR: commonUrl + 'Account/QR2', //获取账号推广二维码

    getBills: commonUrl + 'Commission/Bills', //获取佣金列表
    getWithdraws: commonUrl + 'Commission/Withdraws', //获取提现列表
    withdraw: commonUrl + 'Commission/Withdraw', //提现

    getMyMembers: commonUrl + 'Account/MyMembers', //我的下级

    getUserInfo: commonUrl + 'Account', //获取账号信息，同时会刷新信用额度使用情况
    createBook: commonUrl + 'Orders/Hotel/Create', //创建酒店订单
    checkBookable: commonUrl + 'Orders/Hotel/Check', //检查酒店是否可以预订
    cancelOrder: commonUrl + 'Orders/Cancel', //取消订单
    cancelOnlineOrder: commonUrl + 'Orders/Online/Cancel', //取消直连订单
    getPayParam: commonUrl + 'WXPay/GetPayParam', //获取订单的支付地址
    getPayStatus: commonUrl + 'WXPay/GetPayStatus', //获取订单的支付状态
    checkCoupon: commonUrl + 'Coupon', //验证优惠券码

    getFavorites: commonUrl + 'Favorite', //获取用户的收藏数据
    addFavorite: commonUrl + 'Favorite', //添加收藏
    removeFavorite: commonUrl + 'Favorite/Delete', //删除收藏
    isFavoriteExist: commonUrl + 'Favorite/Exists', //是否已收藏

    // 抢购
    getPreSaleList: commonUrl + 'ZWYPresale/Search', //抢购查询
    getPreSaleStock: commonUrl + 'PreSale/Stock', //抢购已卖数量
    getPreSaleDetails: commonUrl + 'ZWYPresale/Detail', //抢购详情
    getPreSaleQr: commonUrl + 'PreSale/QR', //抢购详情二维码
    getPreSaleMedia: commonUrl + 'ZWYPreSale/Media', //抢购详情图片
    preSaleBook: commonUrl + 'Orders/ZWYPresale/Check', //抢购详情下单检查
    preSaleCreate: commonUrl + 'Orders/ZWYPresale/Create', //抢购详情下单
    getSaleOrderList: commonUrl + 'Orders/Presale/Search', //抢购订单列表
    getSaleOrderDetails: commonUrl + 'Orders', //抢购订单详情

    // 获取自由行
    getPackageList: commonUrl + 'ZWYPackage/Search', //获取自由行查询
    getPriceRange: commonUrl + 'ZWYPackage/PriceRange', //获取自由行酒店价格范围
    getPackageStock: commonUrl + 'ZWYPackage/Prices', //获取自由行产品的日历价格
    getPackageDetails: commonUrl + 'ZWYPackage/Detail', //自由行产品图文信息
    getPackageRr: commonUrl + 'Package/QR', //自由行产品二维码
    getPackageMedia: commonUrl + 'ZWYPackage/Media', //自由行抢购详情图片
    packageBook: commonUrl + 'Orders/ZWYPackage/Check', //自由行产品下单检查
    packageCreate: commonUrl + 'Orders/ZWYPackage/Create', //自由行产品下单
    packageSku: commonUrl + 'Package/SKU', //自由行产品列表


    // online
    getPackageHotCity: commonUrl + 'Package/HotCity', //获取直连热门城市
    getOnlinePackageList: commonUrl + 'Package/Search', //获取直连产品列表
    getOnlinePackageDetail: commonUrl + 'Package/Detail', //获取直连产品详情
    getOnlinePackageSKUs: commonUrl + 'Package/SKUs', //获取直连产品SKUs
    getOnlinePackagePrices: commonUrl + 'Package/Prices', //获取直连产品SKUs
    getOnlinePackageCheck: commonUrl + 'Orders/Package/Check', //直连产品可定检查
    getOnlinePackageCreate: commonUrl + 'Orders/Package/Create', //直连产品下单
    getOnlinePayParam: commonUrl + 'WXPay/Package/GetPayParam', //获取直连订单的支付地址
    getOnlinePackageOrderList: commonUrl + 'Orders/Package/Search', //直连订单列表
    getOnlinePackageOrderDetails: commonUrl + 'Orders/Package/Detail', //直连订单详情
    getOnlineReserveInfo: commonUrl + 'Orders/Package/ReserveInfo', //可预约信息
    getOnlinePackageReserve: commonUrl + 'Orders/Package/Reserve', //预约下单
    cancelOnlinePackageOrder: commonUrl + 'Orders/Package/Cancel', //取消直连订单



    getOnlineList: commonUrl + 'Online/Search', //获取直连产品列表
    getOnlineDetail: commonUrl + 'Online/Detail', //获取直连产品详情
    getOnlineSKUs: commonUrl + 'Online/SKUs', //获取直连产品SKUs
    getOnlinePrices: commonUrl + 'Online/Prices', //获取直连产品每日价格
    getOnlineRequirement: commonUrl + 'Online/Requirement', //获取直连产品所需用户信息
    getOnlineCheck: commonUrl + 'Orders/Online/Check', //直连产品可订检查
    getOnlineCreate: commonUrl + 'Orders/Online/Create', //直连产品下单
    getOnlineOrderList: commonUrl + 'Orders/Online/Search', //直连订单列表
    getOnlineOrderDetails: commonUrl + 'Orders/Online', //直连订单详情
    getOnlineOrderQGProduct: commonUrl + 'Orders/Online/QGProduct', //预定订单详情
    getOnlineReserveDatas: commonUrl + 'Orders/Online/ReserveDatas', //直连订单预约日历
    getOnlineReserve: commonUrl + 'Orders/Online/Reserve', //直连订单预约
    getWebPayUrl: commonUrl + 'WXPay/Reserve/GetPayUrl', //获取h5支付url
    getPayUrl: commonUrl + 'WXPay/GetPayUrl', //获取h5支付url
    getPackagePayUrl: commonUrl + 'WXPay/Package/GetPayUrl', //获取h5支付url


    //门票
    getticketList: commonUrl + 'Ticket/Search', //门票列表
    getticketDetails: commonUrl + 'Ticket/Detail', //门票详情
    getticketDaily: commonUrl + 'Ticket/Prices', //门票价格日历
    getTicketPriceRange: commonUrl + 'Ticket/TicketPriceRange', //根据列表门票价格
    getScenicPriceRange: commonUrl + 'Ticket/ScenicPriceRange', //根据景点获取门票价格
    createTicket: commonUrl + 'Orders/Ticket/Create', //门票下单
    checkTicket: commonUrl + 'Orders/Ticket/Check', //门票可订检查
    getTicketOrderDetails: commonUrl + 'Orders', //门票订单详情

    // 会议
    MeetingCreate: commonUrl + 'MeetingDemand/Create', //创建会议需求
    MeetingGet: commonUrl + 'MeetingDemand/Get', //会议详情
    MeetingSearch: commonUrl + 'MeetingDemand/Search', //会议列表

    // 发票
    InvoiceSave: commonUrl + 'Invoice/Save', //保存发票
    InvoiceSearch: commonUrl + 'Invoice/Search', //发票列表
    InvoiceDatails: commonUrl + 'Invoice', //发票详情


    regist: commonUrl + 'Account/Regist', //注册
    district: commonUrl + 'Data/District', //获取子城市
    captcha: commonUrl + 'Data/Captcha', //获取验证码
    getSMS: commonUrl + 'Data/SMS', //手机登录验证码
    checkLogIn: commonUrl + 'Account/CheckLoginStatus', //检测是否真实登录

    imgUrl: 'http://sz.cnbooking.net/',
    appId: 'wx5f1836dc0b012e9d', //公众号app id


    // 高德地图
    getGDPrices: 'https://api_gd_appointment.cnbooking.net/api/Order/Prices', //获取产品每日价格
    getGDReserveInfo: 'https://api_gd_appointment.cnbooking.net/api/Order/ReserveInfo', //可预约信息
    getGDReserve: 'https://api_gd_appointment.cnbooking.net/api/Order/Reserve', //预约下单




    baiduMapLocation: 'https://api.map.baidu.com/location/ip?ip=&ak=c85jO1c0e0Ti1iBz3jnAGgacO4VMxsij&coor=bd09ll',







}


// WEBPACK FOOTER //
// ./src/components/common/ApiFactory.js